export const AGRO_STATUS_CONFIG = {
    norm: { label: 'норма', color: '#2e7d32', bg: '#e8f5e9' },
    medium: { label: 'средн.', color: '#8a6d1a', bg: '#fff8e1' },
    low: { label: 'низкий', color: '#c62828', bg: '#fdecea' },
};
